import { render } from "./BatteryOwnership.vue?vue&type=template&id=a2348b98"
import script from "./BatteryOwnership.vue?vue&type=script&lang=js"
export * from "./BatteryOwnership.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__